import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.has-own.js';

function setPropertiesToRC(component, properties) {
  var ret = component;
  for (var key in properties) {
    if (Object.hasOwn(properties, key)) {
      ret[key] = properties[key];
    }
  }
  return ret;
}

export { setPropertiesToRC };
